export enum BasisOptions {
  ADVISED = 'Advised basis',
  INTRODUCER = 'Introducer',
}

export interface IBasisForm {
  basis: BasisOptions | '';
}
